import { useQuery } from '@tanstack/react-query'

import type { GetMyProfileResponse } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useGetMyProfileQuery = (enabled = true) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<GetMyProfileResponse>('/me/profile')
      return response.data
    },
    queryKey: meKeys.profile,
    staleTime: 5 * 60 * 1000,
  })
